(function($){
	
	const
	back_to_top = $('.site-footer__back-to-top');

	add_class_cookies_footer()

	
	$( window ).scroll(function() {
		if ( $( this ).scrollTop() >= 400 ) {
			show_back_to_top();
		} else {
			hide_back_to_top();
		}
	});

	$('.site-footer__back-to-top > button').on('click', function() {
		$("html, body").animate({scrollTop: 0}, 400, "linear");
		// return false
	})
	
	function show_back_to_top() {
		back_to_top.addClass('site-footer__back-to-top--is-out')
	}


	
	function hide_back_to_top() {
		back_to_top.removeClass('site-footer__back-to-top--is-out')
	}

	function add_class_cookies_footer(){
		$('li.cookie-item a').prop("href", "javascript:void(0)");
	}
	
})(jQuery);